import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../hooks/ThemeContext';

const RestaurantUnavailable = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '100px',
      padding: '20px',
      textAlign: 'center',
      width: "100%",
      color: theme.textColor
    }}>
      <h2 style={{ marginBottom: '15px', fontWeight: '500' }}>
        This restaurant is coming soon.
      </h2>
      <p style={{ marginBottom: '20px' }}>
        Please select another restaurant to place your order.
      </p>

      <span
        onClick={() => navigate('/')}
        style={{
            backgroundColor: theme.cartButtonColor,
            color: theme.cartButtonTextColor,
            padding: '12px 24px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '500',
            cursor: "pointer"
        }}
      >
        Browse Restaurants
      </span>
    </div>
  );
};

export default RestaurantUnavailable;